module.exports = __webpack_public_path__ + "img/国防科技大学气象海洋学院.14291f9a.png";